import { Alert, Snackbar, Hyperlink } from "@vapor/react-material";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCircleCheck,
  faExclamationTriangle,
} from "@fortawesome/pro-solid-svg-icons";

interface SnackBarAlertProps {
  alertMessage: string;
  linkMessage?: string;
  onClose?: () => void;
  onLinkClick?: () => void;
  open: boolean;
  severity: "success" | "error" | "warning" | "info";
}

const iconMapping = {
  error: faExclamationTriangle,
  info: faExclamationTriangle,
  success: faCircleCheck,
  warning: faExclamationTriangle,
};

//Just add Severity [success,error,warning,info] and alert message to this component
const SnackBarAlert = ({
  alertMessage,
  linkMessage,
  onClose,
  onLinkClick,
  open,
  severity,
}: SnackBarAlertProps) => {
  const handleAlertClose = (event: React.SyntheticEvent) => {
    if (onClose) {
      onClose();
    }
  };

  const handleSnackbarClose = (
    _: React.SyntheticEvent | Event,
    reason?: string
  ) => {
    if (reason === "clickaway") {
      return;
    }
    if (onClose) {
      onClose();
    }
  };

  const Icon = iconMapping[severity];

  return (
    <div>
      <Snackbar
        open={open}
        onClose={handleSnackbarClose}
        autoHideDuration={15000}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
        sx={{
          "& .MuiPaper-root": {
            //For the moment this will have this custom style
            alignItems: "center",
            width: "458px",
            height: "64px",
            marginTop: "50px",
            marginRight: "-30px",
          },
        }}
      >
        <Alert
          onClose={handleAlertClose}
          severity={severity}
          variant="outlined"
          sx={{ width: "100%" }}
          icon={<FontAwesomeIcon icon={Icon} />}
        >
          {alertMessage}{" "}
          {linkMessage && (
            <Hyperlink onClick={onLinkClick}>{linkMessage}</Hyperlink>
          )}
        </Alert>
      </Snackbar>
    </div>
  );
};

export default SnackBarAlert;
